<script lang="ts" setup>
import { ref, reactive } from "vue";

const props = defineProps<{
  text: string;
}>();

const speaking = ref(false);

const speaker = reactive(
  new (window.SpeechSynthesisUtterance ||
    window.webkitSpeechSynthesisUtterance ||
    window.mozSpeechSynthesisUtterance ||
    window.msSpeechSynthesisUtterance)(),
);

const speak = (text) => {
  speaker.lang = "en-US";
  speaker.rate = 1.5;
  speaker.voice = window.speechSynthesis.getVoices()[0];
  speaker.text = text;
  window.speechSynthesis.speak(speaker);
  speaking.value = true;

  speaker.onend = function () {
    speaking.value = false;
  };
};

const stopSpeaking = () => {
  window.speechSynthesis.cancel();
  speaker.text = "";
  speaking.value = false;
};
</script>

<template>
  <div>
    <b-icon
      v-if="!speaking"
      icon="volume-up"
      title="Text to Speech"
      class="s-icon"
      variant="primary"
      @click.prevent="speak(props.text)"
    />
    <b-icon v-else icon="exclamation-circle-fill" class="s-icon" variant="danger" @click.prevent="stopSpeaking" />
  </div>
</template>

<style scope>
.s-icon {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
